const origin = (typeof window.location.origin === 'undefined' ?
    (window.location.protocol + "//" + window.location.host) : window.location.origin);
const prodHost = 'ysdinghuo';
const testHost = 'yimaideng';
const devHost = `http://${location.hostname}`;
const UrlUtil = {
    getHost(){
        if (process.env.API_ENV === 'prod') {
            return prodHost;
        } else if (process.env.API_ENV === 'test') {
            return testHost;
        } else {
            return devHost;
        }
    },
    getAPI() {
        if (process.env.API_ENV === 'prod') {
            return `https://api.${prodHost}.com`;
        } else if (process.env.API_ENV === 'test') {
            return `http://api.yimaideng.cn`;
        } else {
            return `${devHost}:8990`;
        }
    },
    getMShopUrl: () => {
        if (process.env.API_ENV === 'prod') {
            return `https://m.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://m.${testHost}.cn`
        } else {
            return `${devHost}:8991`;
        }
    },
    getMMgrUrl: () => {
        if (process.env.API_ENV === 'prod') {
            return `https://mgr.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://mgr.${testHost}.cn`
        } else {
            return `${devHost}:8996`;
        }
    },
    getLightUrl: () => {
        if (process.env.API_ENV === 'prod') {
            return `https://pd.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://pd.${testHost}.cn`
        } else {
            return `${devHost}:9002`;
        }
    },
    getAccountUrl: (companyID) => {
        if (process.env.API_ENV === 'prod') {
            return companyID ? `https://store${companyID}.${prodHost}.com` : `https://account.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return companyID ? `http://store${companyID}.${testHost}.cn` : `http://account.${testHost}.cn`
        } else if (window.location.href.indexOf('192.168')) {
            return `${devHost}:8993`;
        }
    },
    getBitMapUrl: () => {
        if (process.env.API_ENV === 'prod') {
            return `https://point.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://point.${testHost}.cn`
        } else {
            return `${devHost}:5003`;
        }
    },
};
export default UrlUtil;



// WEBPACK FOOTER //
// ./src/utils/url-config.js